export default "__VITE_ASSET__BSj9KAys__"